export default class IconUtils {
  static THEMES = {
    default: 'default',
    darkBlue: 'darkBlue',
    green: 'green',
    red: 'red',
  };

  static COLORS = {
    [IconUtils.THEMES.default]: {
      fill: '#000000',
      stroke: '#12192B',
    },
    [IconUtils.THEMES.darkBlue]: {
      fill: '#253256',
      stroke: '#253256',
    },
    [IconUtils.THEMES.green]: {
      fill: '#578433',
      stroke: '#578433',
    },
    [IconUtils.THEMES.red]: {
      fill: '#D53B3E',
      stroke: '#4ABF4A',
    },
  };

  static withTheme(theme = IconUtils.THEMES.default) {
    return IconUtils.COLORS[theme] || IconUtils.COLORS[IconUtils.THEMES.default];
  }

  static getColorOrDefault(color, theme = IconUtils.THEMES.default) {
    return {
      fill: color || IconUtils.withTheme(theme).fill,
      stroke: color || IconUtils.withTheme(theme).stroke,
    };
  }
}
